import React from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TrafficPageTemplate from "./TrafficPageTemplate";
import SelectSitePanel from "SelectSitePanel";

class TrafficLandingPage extends React.Component {
  componentDidMount() {
    this.updateRoute(this.props.selectedSite);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedSite !== this.props.selectedSite) {
      this.updateRoute(this.props.selectedSite);
    }
  }

  get initialValues() {
    return { siteId: this.props.selectedSite };
  }

  updateRoute(id) {
    if (id === null) {
      this.props.history.push({ pathname: location.pathname });
    } else {
      this.props.history.push({
        pathname: `${location.pathname}/site/${id}`
      });
    }
  }

  render() {
    return (
      <TrafficPageTemplate>
        <SelectSitePanel />
      </TrafficPageTemplate>
    );
  }
}

function mapStateToProps({ app: { selectedSite } }) {
  return { selectedSite };
}

export default withRouter(connect(mapStateToProps)(TrafficLandingPage));
